import { withErrorBoundary } from "@sentry/nextjs";
import NextLink from "next/link";
import { AnchorHTMLAttributes, FC, ReactNode } from "react";
import { Button, ButtonProps } from "../Button";

interface LinkButtonProps extends ButtonProps<typeof NextLink>, AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  shouldPrefetch?: boolean;
  children: ReactNode;
  prefetch?: boolean;
}

const LinkButton: FC<LinkButtonProps> = withErrorBoundary(
  ({ children, href = "", shouldPrefetch, ...rest }) => (
    // An a tag when prefetch is false is vital since NextLink prefetch={false} still prefetches links on hover
    <Button as={shouldPrefetch ? NextLink : "a"} href={href} prefetch={shouldPrefetch || undefined} {...rest}>
      {children}
    </Button>
  ),
  {}
);

export { LinkButton };
export type { LinkButtonProps };
